import { render, staticRenderFns } from "./ModulCost.vue?vue&type=template&id=ef3649e8&"
import script from "./ModulCost.vue?vue&type=script&lang=js&"
export * from "./ModulCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports